import { React, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectContactFetchResults, selectContactFetchRequest, selectContactCurrentPage, selectContactTotalPages, selectContactRows, selectContactFirst, selectContactFetchStatus, selectContactFilter, selectContactSort } from './store/selectors'
import { setContactFetchStatusAction, setContactFetchResultsAction, setContactTotalPagesAction, setContactFirstAction, setContactRowsAction, setContactCurrentPageAction, setContactFilterAction, setContactSortAction, setContactRefreshAction } from './store/actions'
import { selectMembershipApiHost } from 'globalSelectors'
import { selectAllAssets } from 'providers/AssetLoader/store/selectors'
import { LazyGrid } from 'components/common'
import ContactLandingApi from 'api/DataEntry/Landing/Contact'
import ContactWorksNestedTable from './ContactWorksNestedTable'
import ContactWorksStaticTable from './ContactWorksStaticTable'
import { ContactLandingHeader } from './ContactLandingHeader'
import { createContactColumnDefinitions } from './config/ContactLandingColumns'
import 'primeicons/primeicons.css'
import { Toast } from 'primereact/toast'

const csvDownloadPathSuffix = '/Contact/csvexport?'
const csvDownloadName = 'Contact.csv'
const excelDownloadPathSuffix = '/Contact/excelexport?'
const excelDownloadName = 'Contact.xlsx'

export function ContactLandingContent(props) {   
const toast = useRef(null)
const [expandedRows, setExpandedRows] = useState(null)
    
const contactResults = useSelector(selectContactFetchResults)
const currentPage = useSelector(selectContactCurrentPage)
const first = useSelector(selectContactFirst)
const rows = useSelector(selectContactRows)
const filter = useSelector(selectContactFilter)
const sort = useSelector(selectContactSort)
const membershipApiHost = useSelector(selectMembershipApiHost)
const assets = useSelector(selectAllAssets)

    // Extract company types from assets
    const companyTypes = assets?.companyTypes || []

    const dispatch = useDispatch()
    const setContactRefresh = (status) => dispatch(setContactRefreshAction(status))
    const queryParamsObject = {}
    if (filter) {
        queryParamsObject.filter = filter.toString()
    }

    if (sort) {
        queryParamsObject.sortBy = sort.toString()
    }

    const queryParams = new URLSearchParams(queryParamsObject).toString()
    const excelDownloadPath = membershipApiHost + excelDownloadPathSuffix + queryParams
    const csvDownloadPath = membershipApiHost + csvDownloadPathSuffix + queryParams

    let contactResultList = []
    let contactResultsCount = 0

    if (contactResults) {
        contactResultList = contactResults['results'] || []
        contactResultsCount = contactResults['total'] || 0
    }

    const handleRefresh = (event) => {        
        setContactRefresh(true)        
    }

    const handleAddContact = () => {
        // TODO: Implement add contact functionality
    }

    const header = (
        <ContactLandingHeader
            id={props.id}
            first={first}
            rows={rows}
            totalCount={contactResultsCount}
            csvDownloadPath={csvDownloadPath}
            csvDownloadName={csvDownloadName}
            excelDownloadPath={excelDownloadPath}
            excelDownloadName={excelDownloadName}
            onRefresh={handleRefresh}
            onAddContact={handleAddContact}
        />
    )

    // Works expansion template - uses ContactWorksStaticTable for ≤50 works, ContactWorksNestedTable for >50
    const worksExpansionTemplate = (rowData) => {
        if (rowData.lazyLoadWorks) {
            return (
                <ContactWorksNestedTable
                    key={`works_${rowData.contactId}`}
                    contact={rowData}
                    apiBaseUrl={membershipApiHost}
                    onError={(error) => {
                        toast.current.show(error)
                    }}
                />
            )
        } else {
            return (
                <ContactWorksStaticTable
                    key={`works_${rowData.contactId}`}
                    contact={rowData}
                />
            )
        }
    }

    // Create column definitions with necessary parameters
    const contactColumnDefinitions = createContactColumnDefinitions({
        id: props.id,
        expandedRows,
        setExpandedRows,
        companyTypes
    })

    return (
        <div id={props.id + '_contactList'} >
            <Toast ref={toast} />
            <ContactLandingApi
                id={props.id + '_container_results_contact'}
                key={currentPage + rows}
                setStatusAction={setContactFetchStatusAction}
                setResultsAction={setContactFetchResultsAction}
                requestSelector={selectContactFetchRequest}
                setRefreshAction={setContactRefreshAction}
            />           
            <LazyGrid
                id={props.id + '_contactList_commonGrid'}
                dataKey="contactId"
                header={header}
                data={contactResultList}
                totalCount={contactResultsCount}
                emptyMessage="No Results"
                columnDefinitions={contactColumnDefinitions}
                selectTotalPages={selectContactTotalPages}
                selectFirst={selectContactFirst}
                selectRows={selectContactRows}
                fetchStatusSelector={selectContactFetchStatus}
                setTotalPagesAction={setContactTotalPagesAction}
                setCurrentPageAction={setContactCurrentPageAction}
                setFirstAction={setContactFirstAction}
                setRowsAction={setContactRowsAction}
                setFilterAction={setContactFilterAction}
                setSortAction={setContactSortAction}
                currentPage={currentPage}
                filter={filter}
                sort={sort}
                excelDownloadPath={excelDownloadPath}
                excelDownloadName={excelDownloadName}
                rowExpansionTemplate={worksExpansionTemplate}
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
            />
        </div>
    )
}







